// This file is generated by a script. Do not edit this file directly.
var _excluded = ["className", "type", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
import { cva } from 'cva';
import clsx from 'clsx';
import { cn } from "../../common/utils";
var baseButtonVariants = cva({
  base: clsx('cop-flex cop-items-center cop-justify-center cop-border cop-border-solid cop-rounded cop-transition-opacity cop-shadow-none cop-cursor-pointer', 'disabled:cop-pointer-events-none disabled:cop-cursor-default disabled:cop-text-disabled', 'focus:cop-outline-none focus:cop-outline-[1.5px] focus:cop-outline-[#053299] focus:cop-outline-offset-1'),
  variants: {
    variant: {
      primary: clsx('cop-bg-button-primary cop-text-white cop-border-primary', 'hover:cop-bg-[#6B6F76] hover:cop-border-[#00000012]', 'disabled:cop-bg-secondary disabled:cop-border-[#00000012]'),
      secondary: 'cop-bg-white cop-text-primary cop-border-[#00000012] hover:cop-bg-[#F8F9FB]',
      minimal: 'cop-bg-transparent cop-border-transparent cop-text-primary hover:cop-bg-[#F8F9FB] hover:cop-border-[#F8F9FB]'
    }
  },
  defaultVariants: {
    variant: 'primary'
  }
});
export var BaseButton = function BaseButton(_ref) {
  var className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("button", _extends({
    className: cn(baseButtonVariants({
      variant: variant
    }), className),
    type: type
  }, props));
};
